import type { ClientGroup } from "@stockline/shared/types/crm/client-group"
import { CLIENT_GROUP_TABLE } from "../../../lib/offline/resources/crm/client-group/db"
import { useAISync } from "../../ai/providers/AISyncProvider"

const NO_MATCH_ID = "00000000-0000-0000-0000-000000000000"

/**
 * Reactive single client group lookup by id (offline-first). Always calls the
 * underlying hook to satisfy Rules of Hooks; a `null` id resolves to a
 * sentinel UUID that yields `null`.
 */
export function useClientGroup(id: string | null): ClientGroup | null {
  const { reactive } = useAISync()
  return reactive.useOne<ClientGroup>(CLIENT_GROUP_TABLE, id ?? NO_MATCH_ID)
}
